import { cn, type FileRef, formatSize } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'
import { Spinner } from '@/shared/ui/spinner'
import { useFileDownload } from './use-file-download'

// Файл из FileRef: имя, размер, скачивание. Байты качаются fetch'ем и отдаются
// blob'ом с исходным именем (presigned-URL на чужом origin игнорирует download).
// Пока запрос идёт — спиннер вместо иконки, кнопки заблокированы.

interface FileRowProps {
  file: FileRef
  className?: string
  onRemove?: () => void
}

export function FileRow({ file, className, onRemove }: FileRowProps) {
  const { busy, download } = useFileDownload()

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-control bg-bg-elevated px-3 py-2 text-sm',
        className,
      )}
    >
      <Icon name="document" size={18} className="shrink-0 text-text-tertiary" />
      {file.url ? (
        <button
          type="button"
          onClick={() => void download(file)}
          disabled={busy}
          aria-busy={busy}
          title={file.file_name}
          className="min-w-0 flex-1 truncate text-left text-text-primary transition-colors hover:underline disabled:opacity-40"
        >
          {file.file_name}
        </button>
      ) : (
        <span className="min-w-0 flex-1 truncate text-text-primary" title={file.file_name}>
          {file.file_name}
        </span>
      )}
      <span className="mono-num shrink-0 text-xs text-text-tertiary">{formatSize(file.size)}</span>
      {file.url && (
        <button
          type="button"
          onClick={() => void download(file)}
          disabled={busy}
          aria-label={`Скачать ${file.file_name}`}
          className="inline-flex shrink-0 text-text-tertiary transition-colors hover:text-text-primary disabled:opacity-40"
        >
          {busy ? (
            <Spinner label={`Скачиваем ${file.file_name}`} />
          ) : (
            <Icon name="download" size={16} />
          )}
        </button>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Убрать ${file.file_name}`}
          className="shrink-0 text-text-tertiary transition-colors hover:text-accent"
        >
          <Icon name="close" size={16} />
        </button>
      )}
    </div>
  )
}
